<script>
    import Layout from "../../layouts/main";
    //import appConfig from "@/app.config";
    import config from "../../../config/config";
    import { mapActions} from "vuex";
    // import tinymce from "vue-tinymce-editor";
    import { error_message, success_message, } from "../../../state/helpers";
    import { required } from "vuelidate/lib/validators";
    import DropzonePopup from "../../../components/widgets/dropzone-popup";
    import Multiselect from 'vue-multiselect';
    /**
     * Starter component
     */
    export default {
        components: {  
            Layout,
            DropzonePopup,
            Multiselect,
        },
        data() {
            return {
                config: config,
                form: {
                    image: "",
                    id: "1",
                    name: "",
                    email: "",
                    password: "",
                },
                profile_image: "",
                profile_image_path: "",
                profile_image_delete_url: process.env.VUE_APP_APIURL + 'delete-user-image',
                selectObjectOptions: [
                    { name: 'Vue.js', language: 'JavaScript' },
                    { name: 'Rails', language: 'Ruby' },
                    { name: 'Sinatra', language: 'Ruby' },
                    { name: 'Laravel', language: 'PHP', $isDisabled: true },
                    { name: 'Phoenix', language: 'Elixir' }
                ],
                value: null,
                value2: [],
                options2: [
                    { name: 'Vue.js', language: 'JavaScript' },
                    { name: 'Adonis', language: 'JavaScript' },
                    { name: 'Rails', language: 'Ruby' },
                    { name: 'Sinatra', language: 'Ruby' },
                    { name: 'Laravel', language: 'PHP' },
                    { name: 'Phoenix', language: 'Elixir' }
                ],
                getOptionValue:[],
                tagValue: [
                    { name: 'Javascript', code: 'js' }
                ],
                tagOptions: [
                    { name: 'Vue.js', code: 'vu' },
                    { name: 'Javascript', code: 'js' },
                    { name: 'Open Source', code: 'os' }
                ],
                getTagOptionValue: [],
            };
        },
        validations: {
            form: {
                image: {
                    required,
                },
                name: {
                    required,
                },
                email: {
                    required,
                },
                password: {
                    required,
                },
            },
        },
        mounted(){
        },
        methods: {
            ...mapActions('general',["updateGeneralData"]),
            addGeneralItems() {
                this.$v.$touch();
                if (this.$v.form.$invalid) {
                    return;
                }else{  
                    const fd = new FormData();
                    fd.append("id", this.form.id);
                    fd.append("name", this.form.name);
                    fd.append("email", this.form.email);
                    fd.append("password", this.form.password);
                    fd.append('single_select',this.value.name);
                    this.value2.forEach((value) => {
                        this.getOptionValue.push(value.name);
                    });
                    fd.append('multi_select',this.getOptionValue);
                    this.tagValue.forEach((value) => {
                        this.getTagOptionValue.push(value.name);
                    });
                    fd.append('tag_select',this.getTagOptionValue);
                    if(this.form.image){
                        fd.append("image", this.form.image);
                    }
                    this.updateGeneralData(fd).then((response) => {
                        console.log('response',response);
                        if (response.data.code === 200) {
                            success_message(response.data.msg);
                            this.$router.push({ name: "user-list" });
                        } else {
                            error_message(response.data.mmsg);
                        }
                    });
                }
            },
            addTag (newTag) {
                const tag = {
                    name: newTag,
                    code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
                }
                this.tagOptions.push(tag);
                this.tagValue.push(tag);
            },
            onUserImagedeleted() {
                this.profile_image = "";
            },
        },
    };
</script>

<template>
    <Layout>
        <div class="row">
            <div class="col-12">
            <div
                class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
            >
                <div class="page-title-left avatar-main-icon d-flex">
                <div class="avatar-xs mr-3">
                    <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                    <i class="bx bx-briefcase"></i>
                    </span>
                </div>
                <div class="report-tag">
                    <h4 class="mb-0 font-size-18">Add General Item</h4>
                    <p><router-link :to="{ name: 'general-list'}">General Items</router-link> > Add General Item</p>
                </div>
                </div>
            </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <form @submit.prevent="addGeneralItems">
                    <div class="card">
                        <div class="card-body">
                            <p class="card-title-desc"></p>
                            <div class="row">
                                <div class="form-group"> 
                                    <input id="id" name="id" type="hidden" @id="form.id" v-model="form.id" class="form-control" />
                                </div>
                                <div class="col-sm-6">
                                    <b-form-group id="input-group-1" label="Name" label-for="name" label-class="required">
                                    <b-form-input
                                        id="name"
                                        name="name"
                                        v-model="$v.form.name.$model"
                                        type="text"
                                        placeholder="Name"
                                        :class="{ 'is-invalid': $v.form.name.$error }"
                                    ></b-form-input>
                                    <div v-if="$v.form.name.$error" class="invalid-feedback">
                                        <span v-if="!$v.form.name.required">Name is required.</span>
                                    </div>
                                    </b-form-group>
                                </div>
                                <div class="col-sm-6">
                                    <b-form-group id="input-group-1" label="Email" label-for="email" label-class="required">
                                        <b-form-input
                                            id="email"
                                            name="email"
                                            v-model="$v.form.email.$model"
                                            type="email"
                                            placeholder="Email"
                                            :class="{ 'is-invalid': $v.form.email.$error }"
                                        ></b-form-input>
                                        <div v-if="$v.form.email.$error" class="invalid-feedback">
                                            <span v-if="!$v.form.email.required">Email is required.</span>
                                        </div>
                                    </b-form-group>
                                </div>
                                <div class="col-sm-6">
                                    <b-form-group id="input-group-1" label="Password" label-for="password" label-class="required">
                                    <b-form-input
                                        id="password"
                                        name="password"
                                        v-model="$v.form.password.$model"
                                        type="password"
                                        placeholder="Password"
                                        :class="{ 'is-invalid': $v.form.password.$error }"
                                    ></b-form-input>
                                    <div v-if="$v.form.password.$error" class="invalid-feedback">
                                        <span v-if="!$v.form.password.required">Password is required.</span>
                                    </div>
                                    </b-form-group>
                                </div>
                                <div class="col-sm-6">
                                    <label class="typo__label">Single select / dropdown with Search</label>
                                    <multiselect 
                                        v-model="value" 
                                        deselect-label="Can't remove this value" 
                                        track-by="name" label="name" 
                                        placeholder="Select one"
                                        name="single_select" 
                                        :options="selectObjectOptions" 
                                        :searchable="true" 
                                        :allow-empty="false">
                                        <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.name }}</strong> is written in<strong>  {{ option.language }}</strong></template>
                                    </multiselect>
                                </div>
                                <div class="col-sm-6">
                                    <label class="typo__label">Multiple select / dropdown</label>
                                    <multiselect 
                                        v-model="value2" 
                                        :options="options2" 
                                        :multiple="true" 
                                        :close-on-select="false" 
                                        :clear-on-select="false" 
                                        :preserve-search="true" 
                                        placeholder="Pick some" 
                                        label="name" 
                                        track-by="name"
                                        name="multi_select" 
                                        :preselect-first="true">
                                        <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp;  !isOpen">{{ values.length }} options selected</span></template>
                                    </multiselect>
                                </div>
                                <div class="col-sm-6">
                                    <label>Multiple Tagging</label>
                                    <multiselect 
                                        v-model="tagValue" 
                                        tag-placeholder="Add this as new tag" 
                                        placeholder="Search or add a tag" 
                                        label="name" 
                                        track-by="code" 
                                        :options="tagOptions" 
                                        :multiple="true" 
                                        :taggable="true" 
                                        @tag="addTag"
                                        >
                                    </multiselect>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="margin">Upload Images</label>
                                        <dropzone-popup
                                            type="file"
                                            v-model="form.image"
                                            id="profile_image"
                                            acceptedFiles=".jpeg,.jpg,.png"
                                            multiple
                                            :editable-images="profile_image"
                                            :media-path="profile_image_path+'/original'"
                                            :delete-path="profile_image_delete_url"
                                            :custom-params="{id: $route.params.id}"
                                            :class="{ 'is-invalid': $v.form.image.$error }"
                                            @image-deleted="this.onUserImagedeleted"
                                        />
                                        <div v-if="$v.form.image.$error" class="invalid-feedback cuisine-img">
                                            <span
                                                v-if="!$v.form.image.required"
                                            >Image is required.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <button class="btn btn-primary mr-1 mt-3">Submit</button>
                                    <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">Cancel</b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </Layout>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .margin{
        margin-top: 12px;
    }
</style>